import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Sparkles, X } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';

const FloatingPrakritiButton = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isVisible, setIsVisible] = useState(true);
  const location = useLocation();

  // Hide button on Prakriti Analysis page
  if (location.pathname === '/prakriti-analysis') return null;

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-6 right-6 z-50">
      <AnimatePresence>
        {isExpanded && (
          <motion.div
            initial={{ opacity: 0, scale: 0.8, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.8, y: 20 }}
            className="absolute bottom-20 right-0 w-80 bg-white rounded-3xl shadow-2xl p-6 mb-4"
          >
            <button
              onClick={() => setIsExpanded(false)}
              className="absolute top-4 right-4 text-gray-400 hover:text-gray-600"
            >
              <X className="w-5 h-5" />
            </button>

            <div className="mb-4">
              <Sparkles className="w-12 h-12 text-primary-teal mb-3" />
              <h3 className="text-xl font-bold text-gray-800 mb-2">
                Discover Your Prakriti
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                Take our free Ayurvedic body type analysis and get personalized insights 
                into your fertility health!
              </p>
            </div>

            <div className="space-y-3 mb-4">
              <div className="flex items-center space-x-2 text-sm text-gray-700">
                <span className="w-2 h-2 bg-primary-teal rounded-full"></span>
                <span>40 comprehensive questions</span>
              </div>
              <div className="flex items-center space-x-2 text-sm text-gray-700">
                <span className="w-2 h-2 bg-primary-teal rounded-full"></span>
                <span>Instant personalized results</span>
              </div>
              <div className="flex items-center space-x-2 text-sm text-gray-700">
                <span className="w-2 h-2 bg-primary-teal rounded-full"></span>
                <span>Free fertility insights e-book</span>
              </div>
            </div>

            <Link
              to="/prakriti-analysis"
              className="block w-full bg-gradient-to-r from-primary-teal to-teal-600 text-white text-center py-3 rounded-full font-semibold hover:from-teal-600 hover:to-teal-700 transition-all shadow-lg"
            >
              Start Free Analysis
            </Link>

            <button
              onClick={() => setIsVisible(false)}
              className="mt-3 text-xs text-gray-400 hover:text-gray-600 w-full text-center"
            >
              Don't show this again
            </button>
          </motion.div>
        )}
      </AnimatePresence>

      <motion.button
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.9 }}
        onClick={() => setIsExpanded(!isExpanded)}
        className="bg-gradient-to-r from-primary-teal to-teal-600 text-white rounded-full shadow-2xl hover:shadow-3xl transition-all flex items-center space-x-3 px-6 py-4 group"
      >
        <Sparkles className="w-6 h-6 group-hover:rotate-12 transition-transform" />
        <span className="font-bold text-sm">Free Prakriti Analysis</span>
      </motion.button>
    </div>
  );
};

export default FloatingPrakritiButton;